import React, { useEffect, useState } from "react";
import defaultIcon from '../../../assets/images/profile-user.svg';
import cameraIcon from '../../../assets/images/photo-camera.svg';
import { Button, UploadPhoto } from '../../../common/commonIndex';
import PersonalInformationService from '../../../services/API/personalInformationService';
import { toast } from "react-toastify";

import { DocumentType } from "../../../helper/enum";
import { ImageCropper } from "components/componentIndex";


const StepProfile = ({ handleNextEvent, formData, getPersonalInfo, updatePersonalInfo, currentUser }) => {
    const [profile, setProfile] = useState(formData?.profile);

    useEffect(() => {
        if (formData?.profile) {
            setProfile(formData?.profile);
        } else {
            setProfile('');
        }
        if (formData.email && formData.firstName && formData.lastName && formData.sex && formData.day && formData.month && formData.year) {
            getPersonalInfo();
        }
    });

    const handleSubmit = (event) => {
        event.preventDefault();
        handleProfileUpload();
    };

    const handleProfileUpload = async () => {
        try {
            const formDataRequest = new FormData();
            formDataRequest.append('FileToUpload', profile && profile !== '' ? profile : formData?.profile);
            formDataRequest.append('DocumentType', DocumentType.patientProfileImage);

            const response = await PersonalInformationService.documentUpload(formDataRequest, currentUser?.token);
            if (response?.statusCode === 200) {
                let userData = localStorage.getItem('userData');
                if(userData){
                  const currentUser = JSON.parse(userData);
                  currentUser.result.profileSignedUrl = response.result.documentSignedUrl;
                  localStorage.setItem('userData', JSON.stringify(currentUser));
                }
                localStorage.setItem('patientProfile', response.result.documentSignedUrl);
                if (formData?.email && formData?.firstName && formData?.lastName && formData?.sex && formData?.day && formData?.month && formData?.year) {
                    updatePersonalInfo(formData);
                } else {
                    handleNextEvent(5);
                }
            }
            return response;
        } catch (error) {
            console.error(error);
        }
    }

    const skipCurrentStep = () => {
        if (formData.email && formData.firstName && formData.lastName && formData.sex && formData.day && formData.month && formData.year) {
            updatePersonalInfo(formData)
        } else {
            handleNextEvent(5);
        }
    }
    const setUploadImg = async (data) => {
        setProfile(data);
    }
    return (
        <div className="email-form-container">
            <h2 className="title">Pick a profile photo</h2>
            <p className="sub-title">Add a photo so your care team can esasily identify you.</p>
            <ImageCropper defaultProfileIcon={'https://www.dgvaishnavcollege.edu.in/dgvaishnav-c/uploads/2021/01/dummy-profile-pic.jpg' || defaultIcon} formData={formData} cameraIcon={cameraIcon} setUploadImg={setUploadImg} />

            <form className="mt-0" onSubmit={handleSubmit}>

                <p className="sub-title skip-now-margin cursor-pointer" onClick={skipCurrentStep}>Skip for now</p>
                <Button
                    btnClass={'btn-primary'}
                    btnType={'submit'}
                    btnName={'Next'}
                    onClick={handleSubmit}
                    isDisabled={true}
                />
            </form>
        </div>
    );
}

export default StepProfile;